// removed by extract-text-webpack-plugin
module.exports = {"header":"_1wDrUp7MGpaBdIG67c9OVe","logo":"_2hwuCQJCE5lUHdU6kUE4R9","user":"_2sTz5phBG0YzQM0uq8WpKQ","loginOut":"_1PYel_TxpiWC3q7DtvdLD0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.less
// module id = 740
// module chunks = 0